// Only owner-verified brand profiles are enabled; pending networks stay hidden.
// Never fall back to a platform homepage: that sends customers to the wrong destination.
export const SOCIAL_LINKS = [
  { id: "instagram", label: "Instagram", href: "https://www.instagram.com/shule.accessories/", enabled: true },
  { id: "facebook", label: "Facebook", href: "https://www.facebook.com/profile.php?id=61596026751892", enabled: true },
  { id: "youtube", label: "YouTube", href: "", enabled: false },
  { id: "tiktok", label: "TikTok", href: "", enabled: false },
  { id: "linkedin", label: "LinkedIn", href: "", enabled: false },
  { id: "x", label: "X", href: "", enabled: false },
  { id: "whatsapp", label: "WhatsApp", href: "", enabled: false },
];

export const ACTIVE_SOCIAL_LINKS = SOCIAL_LINKS.filter(
  ({ enabled, href }) => enabled && /^https:\/\//i.test(href)
);
